import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import Upsert from '../../../components/form/Upsert'
import Modal from '../../../components/popup/Modal'

const fields = ['kinhGui', 'congVanSo', 'ngay', 'file']
const required = ['kinhGui', 'congVanSo', 'ngay']
const name = { kinhGui: 'Kính gửi', congVanSo: 'Công văn số', ngay: 'Ngày', file: 'File đính kèm' }
const types = { ngay: 'date', file: 'file' }

export default function AddTraCuu(props) {
  const { toggle, vanBang, save, donVi } = props

  const [xacMinhVanBang, setXacMinhVanBang] = useState({})
  const [error, setError] = useState({})

  useEffect(() => {
    if (vanBang) {
      const noiDung = `Ông/bà: ${vanBang.hoTen}, sinh ngày ${vanBang.ngaySinh} tại ${
        vanBang.noiSinh
      } có tên trong danh sách tốt nghiệp Kỳ thi ${
        vanBang.heDaoTao && vanBang.heDaoTao.name
      } khóa ngày ${vanBang.khoaThi && vanBang.khoaThi.date} tại Hội đồng thi ${
        vanBang.donViDangKyDuThi && vanBang.donViDangKyDuThi.name
      }, huyện ${donVi}; có hồ sơ lưu tại Phòng Giáo dục và Đào tạo huyện ${donVi}.`
      const noiDungDisplay = (
        <span>
          Ông/bà: <b>{vanBang.hoTen}</b>, sinh ngày <b>{vanBang.ngaySinh}</b> tại{' '}
          <b>{vanBang.noiSinh}</b> có tên trong danh sách tốt nghiệp Kỳ thi{' '}
          <b>{vanBang.heDaoTao && vanBang.heDaoTao.name}</b> khóa ngày{' '}
          <b>{vanBang.khoaThi && vanBang.khoaThi.date}</b> tại{' '}
          <b>{vanBang.donViDangKyDuThi && vanBang.donViDangKyDuThi.name}</b>, huyện ${donVi}; có hồ
          sơ lưu tại Phòng Giáo dục và Đào tạo huyện ${donVi}.
        </span>
      )
      setXacMinhVanBang({ noiDung, noiDungDisplay, vanBangId: vanBang.id })
    }
  }, [vanBang])

  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button
        label="Huỷ"
        className="p-button-secondary mr-2"
        onClick={() => {
          if (toggle) toggle()
        }}
      />
      <Button
        onClick={() => {
          const newError = {}
          required.forEach((key) => {
            if (!fields.find((i) => key === i)) {
              return
            }
            if (
              xacMinhVanBang[key] === '' ||
              xacMinhVanBang[key] === undefined ||
              xacMinhVanBang[key] === null
            ) {
              newError[key] = `Trường ${name[key] || key} là bắt buộc!`
            }
          })
          setError(newError)
          if (Object.keys(newError).length === 0) {
            if (save) save(xacMinhVanBang)
            if (toggle) toggle()
          }
        }}
        label="Lưu"
      />
    </div>
  )

  const setup = {
    fields,
    name,
    types,
    required,
    error,
    values: xacMinhVanBang,
    setValues: setXacMinhVanBang,
  }
  return (
    <Modal
      {...props}
      width="80%"
      footer={footer}
      header={`Văn bằng của ${vanBang && vanBang.hoTen}`}
    >
      <div className="flex flex-column">
        <div className="flex justify-content-start">
          <h4>Thông tin cần bổ sung</h4>
        </div>
        <Upsert {...setup} />
        <div className="flex justify-content-start">
          <h4>Thông tin nội dung văn bằng</h4>
        </div>
        {xacMinhVanBang.noiDungDisplay}
      </div>
    </Modal>
  )
}
